import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectWheelchairAccessible = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('wheelchair_accessible')(jsonQuery),
);
